export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  try {
    return new Date(dateString).toLocaleDateString();
  } catch {
    return "N/A";
  }
};

/**
 * Get current year for copyright
 * @returns {number} Current year
 */
export const getCurrentYear = () => new Date().getFullYear();

export const isDateWithin30Days = (dateToCheck) => {
  const today = new Date();
  const inputDate = new Date(dateToCheck);

  // Calculate the difference in milliseconds
  const diffInMs = today - inputDate;

  // Convert ms → days
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

  return diffInDays <= 31;
};
